<template>
  <div>
    <div class="modal fade show in" id="fellowModal">
      <div id="loading" v-if="loading">
        <img src="/images/watson-loading.gif" alt="Loading"/>
      </div>
      <tj-modal v-if="tjModalVisible" :selected-fellow="selectedFellow" :continents="continents" @close-modal="closeModal()" @loaded="loading = false"></tj-modal>
      <jk-modal v-if="jkModalVisible" :selected-fellow="selectedFellow" @close-modal="closeModal()"></jk-modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import TjModal from "./tj-modal.vue";
import JkModal from "./jk-modal.vue";

export default {
  props: ['continents', 'filter'],
  data(){
    return {
      selectedFellow: null,
      tjModalVisible: false,
      jkModalVisible: false,
      loading: true
    }
  },
  async created() {

    const body = document.getElementById('body')
    body.classList.add("no-scroll");

    const response = await axios.get("/actions/community/data/get-alumni-by-id", {
        params: {
          contactId: this.$route.params.id
        }
      });
      this.selectedFellow = response.data

      if(this.selectedFellow.Program_Affiliation__c == 'TJ') {
        this.tjModalVisible = true
      } else {
        this.jkModalVisible = true
      }
  },

  methods: {
    closeModal() {
      this.$router.push({ path: '/WAT50N/map/list' })
      const body = document.getElementById('body')
      body.classList.remove("no-scroll");
    }
  },
  components: {
    TjModal, JkModal
  }
}

</script>

<styles>
  #fellowModal {
    background-color: RGBA(239,238, 228, 0.8 );
    /* z-index: 9999; */
  }
</styles>


// WEBPACK FOOTER //
// scripts/modal.vue